/** Etiqueta de color por rol, para leer de un vistazo quién es quién. */
export default function RoleBadges({ roles = [] }) {
  if (!roles?.length) return <span className="text-muted small">Sin rol</span>;

  return (
    <span className="role-badges">
      {roles.map((role) => (
        <span className={`role-badge role-${role}`} key={role}>
          {role}
        </span>
      ))}
    </span>
  );
}
